import { graphql } from '@generated/gql';

export const FETCH_LOGS_QUERY = graphql(`
  query QueryFetchLogs($input: FetchLogsInput!) {
    fetchLogs(input: $input) {
      logs {
        originalDocument
        newDocument
        changes
        workflowContext {
          workflowCompletionId
          stepId
          subStepId
        }
        timestamp
      }
      totalCount
    }
  }
`);

export const GET_TOTAL_LOGS_QUERY = graphql(`
  query GetTotalLogs($input: FetchLogsInput!) {
    fetchLogs(input: $input) {
      totalCount
    }
  }
`);
